module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "14.953f3e7f.jpg";